import RequestV2 from './request-v2.http';

export default class UserHttpService {
    private static uri = 'users';

    public static updateByProfile(data: {}) {
        return RequestV2.patch(`${this.uri}/profile`, data);
    }

    public static cnpjConsultation(cnpj: string) {
        return RequestV2.get(`${this.uri}/cnpj-consultation/${cnpj}`);
    }
}
